import { getNavigator } from '@rhg/utils/browser';
import {
    getLocale,
    getLanguage,
    SupportedLocale,
    defaultLocale,
    SupportedLanguageType,
} from '@rhg/utils/intl';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import useAppConfig from '../use-app-config';

export function useCurrentLanguage(): SupportedLanguageType {
    const { NEXT_PUBLIC_SUPPORTED_LOCALES: supportedLocales } = useAppConfig();
    const { locale } = useRouter();

    const supportedLocal = supportedLocales.includes(locale ?? '')
        ? locale
        : SupportedLanguageType.EN;
    const [currentLanguage, setCurrentLanguage] = useState(supportedLocal);
    const navigator = getNavigator();

    // Prefer the navigator language over the backend locale
    useEffect(() => {
        if (navigator?.language) {
            setCurrentLanguage(navigator.language);
        }
    }, [navigator]);

    return getLanguage(currentLanguage);
}

export function useCurrentLocale(): SupportedLocale {
    const [currentLocale, setCurrentLocale] = useState<string>(defaultLocale);
    const navigator = getNavigator();

    // Get the navigator locale
    useEffect(() => {
        if (navigator?.language) {
            setCurrentLocale(navigator.language);
        }
    }, [navigator]);

    return getLocale(currentLocale);
}
